import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { apiClient } from "src/services/config/apiClient";
import { API } from "src/services/config/apiConfig";

import { ChangePasswordPayload } from "./NetTypes";

async function changePasswordRequest({ oldPassword, newPassword }: ChangePasswordPayload) {
	return await apiClient
		.put(API.COMMAND.USER.CHANGE_PASSWORD, {
			oldPassword,
			newPassword
		})
		.then((res) => res.data);
}

export function useChangePasswordRequest() {
	return useMutation<any, AxiosError, ChangePasswordPayload>({
		mutationFn: (payload: ChangePasswordPayload) => changePasswordRequest(payload)
	});
}
